import { styled } from '@mui/system';

export const TableContainerDiv = styled('div')(({ theme }) => ({
	marginTop: '3vh'
}));
